import { Stack } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useQueryClient } from "@tanstack/react-query";

import FriendsBlankState from "../components/BlankState";
import FriendRow from "../components/FriendRow";
import { useCancelOutboundFriendRequest } from "../hooks/useCancelFriendRequest";
import { type WorkerPublicProfile } from "../hooks/useGetWorkerPublicProfile";

interface Props {
  friends: WorkerPublicProfile[];
}
export default function TabPending(props: Props) {
  const { friends } = props;

  const { showSuccessToast, showErrorToast } = useToast();
  const queryClient = useQueryClient();

  const { mutate: cancelOutboundFriendRequest, isLoading } = useCancelOutboundFriendRequest({
    onSuccess: () => {
      showSuccessToast("Friend request canceled");
      void queryClient.invalidateQueries({ queryKey: ["outbound-friends-requests"] });
    },
    onError: () => {
      showErrorToast("Failed to cancel friend request. Please try again.");
    },
  });

  if (!friends?.length) {
    return <FriendsBlankState />;
  }

  return (
    <Stack spacing={6}>
      {friends.map((friend) => (
        <FriendRow
          key={friend.id}
          friend={friend}
          actions={
            <LoadingButton
              isLoading={isLoading}
              size="small"
              variant="outlined"
              onClick={() => {
                cancelOutboundFriendRequest(friend.id);
              }}
            >
              Cancel
            </LoadingButton>
          }
        />
      ))}
    </Stack>
  );
}
